import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('https://fboothapi.azurewebsites.net/api/auth/customer', {
        username: email,
        password: password,
      });

      if (response.status === 200) {
        const token = response.data.tokenId;
        const decodedToken = jwtDecode(token);
        localStorage.setItem('userToken', token);
        localStorage.setItem('user', JSON.stringify(decodedToken));
        sessionStorage.setItem('userToken', token);
        sessionStorage.setItem('user', JSON.stringify(decodedToken));
        navigate('/');
        window.location.reload();
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (error) {
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="h-full pt-10 pb-60">
      <div className="mx-auto">
        <div className="flex justify-center px-6 py-12">
          <div className="w-full xl:w-3/4 lg:w-11/12 flex rounded-lg shadow">
            <div className="w-full h-auto bg-gray-400 hidden lg:block lg:w-5/12 bg-cover rounded-l-lg">
              <img src={require('../../assets/homepage1.jpg')} alt="User Cover"
                className='w-full h-full rounded-tl-lg rounded-bl-lg ' />
            </div>
            <div className="w-full lg:w-7/12 bg-white p-5 rounded-lg lg:rounded-l-none">
              <h3 className="py-4 text-2xl text-center text-gray-800">Sign In</h3>
              <form className="px-8 pt-6 pb-8 mb-4 bg-white rounded" onSubmit={handleLogin}>
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="email">Email</label>
                  <input
                    className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
                <div className="mb-4 relative">
                  <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="password">Password</label>
                  <input
                    className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter Password"
                  />
                  <div
                    className="text-gray-500 absolute pt-3 inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    ) : (
                      <FontAwesomeIcon icon={faEye} />
                    )}
                  </div>
                </div>
                {error && <p className="text-red-500 text-xs italic">{error}</p>}
                <div className="mb-6 text-center">
                  <button
                    className="w-full px-4 py-2 font-bold text-white bg-blue-500 rounded-full hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-900 focus:outline-none focus:shadow-outline"
                    type="submit"
                  >
                    LOGIN
                  </button>
                </div>
                <div className="text-center">
                  <p className="text-sm text-gray-700">
                    You do not have an account?{' '}
                    <Link to="/register" className="text-blue-500 hover:text-blue-700">
                      Register please
                    </Link>
                  </p>
                </div>
                <div className="text-center mt-4">
                  <p className="text-sm text-gray-700">
                    <Link to="/" className="text-blue-500 hover:text-blue-700">
                      Go Home Page
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
